import React, {useState} from 'react';
import {CardStyled} from "../../../styled/Subscriptions";
import {useTheme} from "../Theme/ThemeContext"
import Button from "../Buttons/Button";
import Modal from "./Modal";
import {ModalContainerStyled} from "../../../styled/Modal";


const BasicPlan = ({data}) => {
    const [selectedPlan, setSelectedPlan] = useState( null);
    const {themeName} = useTheme();


    return (
        <>
        {
            Object.entries(data).map(([productTitle, plans]) => (
                <CardStyled key={productTitle} theme={themeName}>
                    {plans.length !== 0 &&
                        <div className="available">
                            <h2>{productTitle}</h2>
                            {plans.map((plan, index) => (
                                <div key={index}  className="items">
                                    <div className="info">
                                        <p>{plan.duration}</p>
                                        <p>{plan.price} {plan.currency}</p>
                                    </div>
                                    <p>Get a <span className='discount'>{plan.discount}</span> off product, see full plan for details</p>
                                </div>

                            ))}


                            <div className='btn'>
                                <Button alternate={true}  $pad='0.7rem 1rem' clickHandle={() => setSelectedPlan({title: productTitle, data: plans})} theme={themeName}
                                        title={'See full plan'} color='#5fbec5'/>
                            </div>
                        </div>
                    }

                    {plans.length === 0 &&
                        <div className='unavailable'>
                            <h2>{productTitle}</h2>

                            <div className="items">
                                <div className="info">
                                    <p>Per Use</p>
                                    <p>**** ***</p>
                                </div>
                                <p>Get a <span className='discount'>30%</span> off product</p>
                            </div>
                            <div className="items">
                                <div className="info">
                                    <p>Per Week</p>
                                    <p>**** ***</p>
                                </div>
                                <p>Get a <span className='discount'>50%</span> off product and some services</p>
                            </div>
                            <div className="items">
                                <div className="info">
                                    <p>Per Month</p>
                                    <p>***** ***</p>
                                </div>
                                <p>Get a <span className='discount'>75%</span> off product and all services</p>
                            </div>

                            <div className='btn'>
                                <Button alternate={true} $pad='0.7rem 1rem' theme={themeName} title={'See full plan'} color='#5fbec5'/>
                            </div>

                            <span className="comingSoon">
                                <p>Coming soon</p>
                            </span>
                        </div>
                    }
                </CardStyled>

            ))

        }
            {selectedPlan &&
                (
                    <ModalContainerStyled>
                        <Modal plan={selectedPlan.data} title={selectedPlan.title} open={!!selectedPlan}
                               setOpen={() => setSelectedPlan(null)}/>
                    </ModalContainerStyled>
                )
            }
        </>

    )
}

export default BasicPlan;